import { Box } from '@mui/material';
import { Outlet, Route, Routes } from 'react-router-dom';
import { useConfig } from './config/configContext';
import NotFound from './pages/404';
import { LobbyRoute } from './pages/Lobby';
import { PeekRoomRoute } from './pages/PeekRoom';
import { RoomRoute } from './pages/Room';
import { RoomList } from './pages/RoomList';
import { Timer } from './pages/Timer';

const App = ({ ...props }) => {
    return (
        <Box display='flex' flexDirection={'column'} alignItems={'center'} justifyContent={'center'} minHeight={'100vh'} p={2}>
            <Outlet />
        </Box>
    )
}

function AppWrapper() {
    //depending on the config.startPage, we register the index route to either the lobby or the room list or the timer
    const { startPage } = useConfig();
    let startElement = <RoomList />;
    switch (startPage) {
        case "lobby":
            startElement = <LobbyRoute />;
            break;
        case "timer":
            startElement = <Timer />;
            break;
        default:
            break;
    }

    return (
        <Routes>
            <Route
                path="/"
                element={<App />}
            >
                <Route
                    index
                    element={startElement} />
                <Route
                    path="timer"
                    element={<Timer />} />
                <Route
                    path="lobby"
                    element={<LobbyRoute />} />
                <Route
                    path='/lobby/:lobbyName'
                    element={<LobbyRoute />} />
                <Route
                    path="room"
                    element={<RoomList />} />
                <Route
                    path='/room/:roomName'
                    element={<RoomRoute />} />
                <Route
                    path='/peekroom/:roomName'
                    element={<PeekRoomRoute />} />
                <Route
                    path='/peek/:roomName'
                    element={<PeekRoomRoute />} />
                <Route
                    path='/*'
                    element={<NotFound />} />
            </Route>

        </Routes>
    );
}

export default AppWrapper;
